<template>
  <div class="pb-5 sm:flex sm:items-center sm:justify-between mb-2">
    <div class="leading-10 xl:text-xl text-lg text-gray-500 whitespace-nowrap pr-3">
      <slot name="title"></slot>
    </div>
    <div class="flex flex-wrap md:flex-row lg:flex-row gap-2">
      <slot name="filter"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PageHeader',
})
</script>
